import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Quiz} from "./quiz";
import {AuthService} from "./auth.service";
import {Http, Response, RequestOptions, Headers} from "@angular/http";
import {QuizVersion} from "./quiz-version";

@Injectable()
export class QuizService {
  public quizzes$: BehaviorSubject<Quiz[]> = new BehaviorSubject<Quiz[]>([]);
  public quizVersion$: BehaviorSubject<QuizVersion> = new BehaviorSubject<QuizVersion>(null);

  constructor(private authService: AuthService,
              private  http: Http) {
    authService.currentAdmin$.subscribe(admin => {
      this.loadQuizList();
    });
  }

  public loadQuizList(): void {
    this.http.get("api/quiz/list").subscribe(
      res => {
        const data = res.json();
        if (data.quizzes) {
          // console.log("Quiz Service: new quiz data!");
          this.quizzes$.next(data.quizzes);
        } else {
          console.log("Warning: response had no quizzes");
        }
      },
      error => {
        console.error(error);
      }
    );
    this.http.get("api/quiz/version").subscribe(
      res => {
        const data = res.json();
        if (data.version) {
          this.quizVersion$.next(data.version);
        } else{
          console.log("Warning: response had no quiz version");
        }
      }
    );
  }

  addQuiz(quiz: Quiz): Observable<boolean> {
    let body = JSON.stringify({quiz: quiz});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.post("api/quiz/", body, options)
      .map(res => {
        let data = res.json();

        if (data.status && data.status === "Success") {
          if (data.quizzes) {
            // console.log("new question data!");
            this.quizzes$.next(data.quizzes);
          }
          else {
            console.log("Warning: response had no quizzes");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  saveVersion(version: QuizVersion) : Observable<boolean>{
    let body = JSON.stringify({quizVersion : version});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.post("api/quiz/version", body,options)
      .map(res => {
        return true;
      })
      .catch(this.handleError);
  }

  removeQuiz(id: string): Observable<boolean> {
    return this.http.delete("api/quiz/" + id)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.quizzes) {
            //console.log("new question data!");
            this.quizzes$.next(data.quizzes);
          }
          else {
            console.log("Warning: response had no quizzes");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  updateQuiz(quiz: Quiz): Observable<boolean> {
    let body = JSON.stringify({quiz: quiz});
    let headers = new Headers({'Content-Type': 'application/json'});
    let options = new RequestOptions({headers: headers});

    return this.http.put("api/quiz/", body,options)
      .map(res => {
        let data = res.json();
        if (data.status && data.status == "Success") {
          if (data.quizzes) {
            //console.log("new question data!");
            this.quizzes$.next(data.quizzes);
          }
          else {
            console.log("Warning: response had no quizzes");
          }
          return true;
        }
        return false;
      })
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  public getQuiz(quizID: string): Quiz {
    if (!this.quizzes$ || !this.quizzes$.value) {
      return null;
    } else {
      console.log(this.quizzes$.value.length);
      return this.quizzes$.value.find(q => q._id.toString() === quizID);
    }
  }


  // Removes all the players and answers associated with the quiz
  public clearQuiz(quiz: Quiz) {

    let body = JSON.stringify({quiz: quiz});
    let options = new RequestOptions({headers: new Headers({'Content-Type': 'application/json'})});

    return this.http.post("api/quiz/clear", body, options);

  }

}



// WEBPACK FOOTER //
// ./src/app/quiz.service.ts